var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_9291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4141 7.75812L19.2419 6.58594C18.8516 6.19531 18.3397 6 17.8278 6C17.316 6 16.8041 6.19531 16.4135 6.58562L5.40159 17.5975L5.00472 21.1669C4.95472 21.6163 5.30878 22 5.74847 22C5.77628 22 5.80409 21.9984 5.83253 21.9953L9.39941 21.6012L20.4144 10.5862C21.1953 9.80531 21.1953 8.53906 20.4141 7.75812ZM8.94034 20.6462L6.03316 20.9684L6.35691 18.0569L14.6035 9.81031L17.19 12.3969L8.94034 20.6462ZM19.7072 9.87937L17.8969 11.6897L15.3103 9.10313L17.1207 7.29281C17.3094 7.10406 17.5607 7 17.8278 7C18.095 7 18.346 7.10406 18.535 7.29281L19.7072 8.465C20.0969 8.855 20.0969 9.48938 19.7072 9.87937Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ae0d4434404c121a410f23a7a5e93357.svg";
export { ForwardRef as ReactComponent };